<template>
    <div class="flex flex-wrap">
        <div
            v-for="(item, index) in items"
            :key="index"
            :class="getItemClasses(index)"
        >
            <div class="flex flex-col items-center p-6">
                <!-- Image/Avatar -->
                <avatar
                    v-if="item.imageUrl"
                    :url="item.imageUrl"
                    width="45px"
                    height="45px"
                />

                <!-- Icon -->
                <div v-else-if="item.icon" class="mb-2">
                    <i class="text-3xl mb-5" :class="item.icon"></i>
                </div>

                <!-- Title -->
                <h4 class="m-t-5 text-center">{{ item.title }}</h4>

                <!-- Description -->
                <small class="text-muted text-center">{{ item.description }}</small>

                <!-- Link -->
                <a v-if="item.link" :href="item.link" class="text-center mt-2 cursor-pointer">
                    <small>{{ item.linkText }}</small>
                </a>

                <!-- Links [Array of objects (title and link)] -->
                <div v-if="item.links" class="text-center mt-2 flex flex-col">
                    <a
                        v-for="(link, i) in item.links"
                        :key="i"
                        :href="!link.enableLinks ? null : link.link"
                        :class="!link.enableLinks ? 'pointer-events-none text-grey-800' : 'cursor-pointer'"
                    >
                        <small>{{ link.title }}</small>
                    </a>
                </div>

                <!-- Event -->
                <a v-if="item.triggerEvent" @click.prevent="item.triggerEvent" class="text-center mt-2 cursor-pointer">
                    <small>{{ item.triggerEventText }}</small>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from '@/system/components/global/Avatar';

export default {
    components: {
        Avatar
    },

    props: {
        items: {
            type: Array,
            required: true,
            validator: value => {
                return value.every(item => (
                    item.title &&
                    (item.imageUrl || item.icon) &&
                    item.description
                ));
            },
        },
    },

    computed: {
        itemsPerRow() {
            return 2; // for now, I am just keeping it 2, but can be made 3, if the modal is larger
        },
    },
    methods: {
        getItemClasses(index) {
            const totalItems = this.items.length;

            const itemsPerRow = this.itemsPerRow;

            const totalRows = Math.ceil(totalItems / itemsPerRow);

            const currentRow = Math.floor(index / itemsPerRow) + 1;

            const isFirstInRow = index % itemsPerRow === 0;

            const itemsInCurrentRow =
                currentRow < totalRows
                    ? itemsPerRow
                    : totalItems % itemsPerRow || itemsPerRow;

            let widthClass = '';

            if (itemsInCurrentRow === 1) {
                widthClass = 'w-full';
            } else if (itemsInCurrentRow === 2) {
                widthClass = 'w-1/2';
            } else if (itemsInCurrentRow === 3) {
                widthClass = 'w-1/3';
            }

            let classes = `${widthClass} item-border border-solid border-0`;

            if (!isFirstInRow && itemsInCurrentRow > 1) {
                classes += ' border-l border-grey-200';
            }

            classes += ' border-t border-grey-200';

            return classes;
        },
    },
};
</script>
